import React, { useMemo, useState } from "react"
import { isEmpty } from 'lodash';
import './_style.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Atoms
import ButtonEdgeRounded from "§/src/components/atoms/buttons/button-edge-rounded"

// New import for the modal
import FullScreenGalleryModal from "./FullScreenGalleryModal";

const ZoomIcon = () => (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none">
    <path d="M19.793 19.2928L15.4498 14.9497M15.4498 14.9497C16.8975 13.502 17.793 11.502 17.793 9.29285C17.793 4.87457 14.2112 1.29285 9.79297 1.29285C5.37469 1.29285 1.79297 4.87457 1.79297 9.29285C1.79297 13.7111 5.37469 17.2928 9.79297 17.2928C12.0021 17.2928 14.0021 16.3974 15.4498 14.9497Z" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
    <path d="M9.793 6.29285L9.793 12.2928" stroke="currentColor" stroke-width="1" stroke-linecap="square"/>
    <path d="M6.793 9.29285L12.793 9.29285" stroke="currentColor" stroke-width="1" stroke-linecap="square"/>
  </svg>
);

const Gallery = ( props ) => {
  const slider = props.data;
  const imgFit = props.fit;
  const defAlt = props.defAlt;
  const zoomActive = props.zoom;

  const sliderId = useMemo(() => "gallery-zoom-" + Math.floor(Math.random() * 9999), [])
  const totalSlides = slider.length
  const [index, setIndex] = useState(1)
  const [swiperRef, setSwiperRef] = useState(null)

  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // set component class
  const compClassName = 'pb-5';
  var compClass = props.className != undefined ? compClassName + ' ' + props.className : compClassName;

  const openModal = () => {
    setIsModalOpen(true);
  };

  return !isEmpty(slider) ? (
    <div
      comp="gallery"
      className={compClassName}
    >
      <div className="zoom-area">
        <Swiper
          onSwiper={setSwiperRef}
          onSlideChange={swiper => {
            setIndex(swiper.realIndex + 1)
          }}
          slidesPerView={1}
          spaceBetween={0}
          loop={slider?.length === 1 ? false : true}
          watchOverflow={true}
          modules={[Pagination, Navigation]}
          className="simple-swiper"
          id={sliderId}
        >
          {slider.map((heroSlide, pageIndex) => {
            return(
              <SwiperSlide key={pageIndex}>
                <div
                  className="image-container"
                  style={{ position: 'relative' }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={openModal}
                >
                  {heroSlide?.gatsbyImage && (
                    <GatsbyImage
                      className="sw-image"
                      image={getImage(heroSlide.gatsbyImage)}
                      objectFit={imgFit}
                      alt={heroSlide?.altText || defAlt || ''}
                    />
                  )}
                  {isHovered && zoomActive && (
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '1.25rem',
                        right: '1.25rem',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '50%',
                        padding: '12px',
                        cursor: 'pointer'
                      }}
                    >
                      <ZoomIcon />
                    </div>
                  )}
                </div>
              </SwiperSlide>
            )
          })}

          {totalSlides > 1 && (
            <div className="sw-navigation">
              <ButtonEdgeRounded
                id={sliderId + "-nav-prev"}
                dir="start"
                onClick={() => swiperRef.slidePrev()}
              ></ButtonEdgeRounded>
              <ButtonEdgeRounded
                id={sliderId + "-nav-next"}
                dir="end"
                onClick={() => swiperRef.slideNext()}
              ></ButtonEdgeRounded>
            </div>
          )}
        </Swiper>
      </div>

      {totalSlides > 1 && (
        <div className="swiper-main-pagination position-relative pt-3">
          <div
            id={`${sliderId}-pagination`}
            className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"
          >
            {slider.map((elem, i) => (
              <span
                key={i}
                className={classNames("swiper-pagination-bullet", {
                  "spinner-border": i + 1 === index,
                  "border-dark": i + 1 === index,
                })}
                onClick={() => swiperRef.slideTo(i)}
              ></span>
            ))}
          </div>
        </div>
      )}

      <FullScreenGalleryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        images={slider}
        initialIndex={index - 1}
      />
    </div>
  ) : ('');
};

export default Gallery;
